var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"logo-span",attrs:{"to":{name:'Home'},"tag":"span"}})],1),_vm._v(" "),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e6b4ae","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FixedBar.vue
// module id = null
// module chunks = 